<template>
    <div>
        <div style="position: relative">
            <!-- 搜索框 -->

            <div class="tab-box df aic jcsb">
                <div>
                    <span class="mr-34 cup" :class="activeName == 10 ? 'active' : ''" @click="handleClick(10)">{{
                        $t("活动") }}</span>
                    <span class="mr-34 cup" :class="activeName == 20 ? 'active' : ''" @click="handleClick(20)">{{
                        $t("话题") }}</span>
                    <span class="mr-34 cup" :class="activeName == 30 ? 'active' : ''" @click="handleClick(30)">{{
                        $t("讨论") }}</span>
                    <span class="mr-34 cup" :class="activeName == 40 ? 'active' : ''" @click="handleClick(40)">{{
                        $t("合作") }}</span>
                </div>

                <div class="search-box">
                    <div class="input-box">
                        <template>
                            <el-input v-model="search_key" :placeholder="$t('请输入关键字')"
                                @keyup.enter.native="handleSearch">
                                <i slot="suffix" class="el-input__icon el-icon-search" @click="handleSearch"></i>
                            </el-input>
                        </template>
                    </div>
                </div>
            </div>

            <div v-show="activeName == 10">
                <!-- 活动列表 -->
                <div class="active-listcontent df fww">
                    <div class="list" v-for="(item, index) in dataList"
                        @click="$navigate('/activity/info', item.ta_id)">
                        <div class="img-box">
                            <el-image :src="item.ta_thumb" fit="cover">
                                <div slot="error" class="image-slot">
                                    <img src="@/assets/images/news-default.png" alt="" />
                                </div>
                            </el-image>
                        </div>
                        <div class="list-box">
                            <div class="title mic-semblod one-text">{{ item.ta_title }}</div>
                            <div class="desc one-text" style="white-space: nowrap">
                                {{ item.ta_desc }}
                            </div>
                            <div class="date-box df aic jcsb">
                                <div class="le over-h">
                                    <div class="address one-text">
                                        <span class="iconfont">&#xe61f;</span>{{ item.ta_city_text }}
                                    </div>
                                    <div class="date">
                                        <span class="iconfont">&#xe602;</span>
                                        {{ item.ta_start_time }}
                                    </div>
                                </div>
                                <div class="ri fn">
                                    <el-button type="success" class="end" v-if="item.is_sign_up == 10">
                                        {{ $t("活动已结束") }}
                                    </el-button>
                                    <el-button type="success" v-else-if="item.is_sign_up == 20">
                                        {{ $t("即将举行") }}
                                    </el-button>
                                    <el-button type="success" v-else-if="item.is_sign_up == 30">
                                        {{ $t("活动报名中") }}
                                    </el-button>
                                    <el-button type="success" v-else-if="item.is_sign_up == 40">
                                        {{ $t("活动进行中") }}
                                    </el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="no-data pt-86" v-if="dataList.length == 0">
                        <img src="@/assets/images/empty_data.png" alt="" />
                        <p>{{ $t("暂无数据") }}</p>
                    </div>
                </div>
            </div>
            <div v-show="activeName == 20">
                <div class="subject-listcontent">
                    <div class="list" v-for="(items, indexs) in dataList" :key="indexs"
                        @click="$navigate('/subject/info', items.ttar_id)">
                        <div class="t1s df jcsb aic over-h">
                            <div class="mic-semblod one-text">
                                <span class="essence" v-if="items.ttar_rec == 900">{{
                                    $t("精1")
                                }}</span>

                                <!-- <span class="hot">{{ $t("热") }}</span> -->
                                <span class="hot" style="background-color: #fdb906ff" v-if="items.ttar_rec == 1000">{{
                                    $t("顶1")
                                }}</span>
                                {{ items.ttar_title }}
                            </div>
                        </div>
                        <div class="desc tow-text" :title="items.ttar_desc">
                            {{ items.ttar_desc }}
                        </div>

                        <div class="userinfo-box df jcsb aic over-h">
                            <div class="users df aic f1 over-h">
                                <div @click="(event) => handleaAvatar(event, items)" class="df">
                                    <template v-if="items.ttar_type == 10">
                                        <el-avatar :size="18" :src="items.user_avatar_att_url" class="fn"
                                            @error="$erroravatarHandler">
                                            <img src="@/assets/images/avatar.png" alt="" />
                                        </el-avatar>
                                    </template>
                                    <template v-else>
                                        <el-avatar :size="18" :src="require('@/assets/images/avatar.png')"
                                            class="fn"></el-avatar>
                                    </template>
                                </div>
                                <span class="name fn">
                                    {{
                                        items.is_expert == 10
                                            ? items.user_name
                                            : items.ttar_type == 20 ||
                                                items.user_id == 0 ||
                                                items.user_nick_name === "" ||
                                                items.user_nick_name === null
                                                ? $t("匿名用户")
                                                : items.user_nick_name
                                    }}
                                </span>

                                <div class="f1 type one-text"
                                    v-if="items.user_excel_arr && items.user_excel_arr.length">
                                    <span v-for="items1 in items.user_excel_arr" :key="items1.label">{{ items1.label
                                    }}</span>
                                </div>
                            </div>

                            <div class="dates df fn">
                                <div class="comment-list df">
                                    <div class="li">
                                        <span class="iconfont">&#xe611;</span>
                                        <span class="text">{{ items.ttar_hits }}</span>
                                    </div>
                                    <div class="li">
                                        <span class="iconfont">&#xe61b;</span>
                                        <span class="text">{{ items.ttar_likes }}</span>
                                    </div>
                                    <div class="li">
                                        <span class="iconfont">&#xe63e;</span>
                                        <span class="text">{{ items.reply_count }}</span>
                                    </div>
                                </div>
                                <span class="date">{{ items.create_time }}</span>
                            </div>
                        </div>
                    </div>

                    <!-- <div class="pager-box df jcc">
  <el-pagination :total="pagination.total" :current-page="pagination.page" :page-size="10"
    layout="prev,slot, next" @current-change="handleCurrentChange">
    <template><span class="page-slot">{{ pagination.page }}/{{ pagination.last_page }}</span></template>
  </el-pagination>
</div> -->

                    <div class="no-data pt-86" v-if="dataList.length == 0">
                        <img src="@/assets/images/empty_data.png" alt="" />
                        <p>{{ $t("暂无数据") }}</p>
                    </div>
                </div>
            </div>
            <div v-show="activeName == 30">
                <div class="subject-listcontent">
                    <div class="list" v-for="(items, indexs) in dataList" :key="indexs"
                        @click="$navigate('/discuss/info', items.tp_id)">
                        <div class="t1s df jcsb aic over-h">
                            <div class="mic-semblod one-text">
                                <span class="essence" v-if="items.tp_rec == 900">{{
                                    $t("精1")
                                }}</span>

                                <!-- <span class="hot">{{ $t("热") }}</span> -->
                                <span class="hot" style="background-color: #fdb906ff" v-if="items.tp_is_top == 10">{{
                                    $t("顶1")
                                }}</span>
                                {{ items.tp_title }}
                            </div>
                        </div>
                        <div class="desc tow-text" :title="items.tp_desc">
                            {{ items.tp_desc }}
                        </div>

                        <div class="userinfo-box df jcsb aic over-h">
                            <div class="users df aic f1 over-h">
                                <div @click="(event) => handleaAvatar(event, items)" class="df">
                                    <template v-if="items.tp_type == 10">
                                        <el-avatar :size="18" :src="items.user_avatar_att_url" class="fn"
                                            @error="$erroravatarHandler">
                                            <img src="@/assets/images/avatar.png" alt="" />
                                        </el-avatar>
                                    </template>
                                    <template v-else>
                                        <el-avatar :size="18" :src="require('@/assets/images/avatar.png')"
                                            class="fn"></el-avatar>
                                    </template>
                                </div>
                                <span class="name fn">
                                    {{
                                        items.is_expert == 10
                                            ? items.user_name
                                            : items.tp_type == 20 ||
                                                items.user_id == 0 ||
                                                items.user_nick_name === "" ||
                                                items.user_nick_name === null
                                                ? $t("匿名用户")
                                                : items.user_nick_name
                                    }}
                                </span>

                                <div class="f1 type one-text"
                                    v-if="items.user_excel_arr && items.user_excel_arr.length">
                                    <span v-for="items1 in items.user_excel_arr" :key="items1.label">{{ items1.label
                                    }}</span>
                                </div>
                            </div>

                            <div class="dates df fn">
                                <div class="comment-list df">
                                    <div class="li">
                                        <span class="iconfont">&#xe611;</span>
                                        <span class="text">{{ items.tp_hits }}</span>
                                    </div>
                                    <div class="li">
                                        <span class="iconfont">&#xe61b;</span>
                                        <span class="text">{{ items.tp_likes }}</span>
                                    </div>
                                    <div class="li">
                                        <span class="iconfont">&#xe63e;</span>
                                        <span class="text">{{ items.reply_count }}</span>
                                    </div>
                                </div>
                                <span class="date">{{ items.create_time }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="no-data pt-86" v-if="dataList.length == 0">
                        <img src="@/assets/images/empty_data.png" alt="" />
                        <p>{{ $t("暂无数据") }}</p>
                    </div>
                </div>
            </div>
            <div v-show="activeName == 40">


                <div class="tb-list df fww mt-24">
                    <template v-for="(item, index) in column">
                        <div class="li lh-22 mr-24 cup" :class="{
                            active: columId == item.tcbc_id,
                            actives: columId == 0 && index == 0,
                        }" @click="handlecp('40', item.tcbc_id)">
                            {{ item.tcbc_title }}
                        </div>
                    </template>
                </div>
                <div class="mt-16 mb-16" v-if="directory_list.length > 0">
                    <el-cascader v-model="value" :options="directory_list" :props="cascaderProps"
                        @change="handleChange"></el-cascader>
                </div>




                <div class="cooperate-listcontent" :class="{ 'df fww': curr_directory_data.tcbcd_temp_type == 30 }">

                    <template v-for="(item, index) in dataList">

                        <!-- 分享 -->
                        <div class="list p-16 cup" v-if="curr_directory_data.tcbcd_temp_type == 10" @click="handleCooperateClick(item)">
                            <div class="df aic one-text mb-12">
                                <span class="essence" v-if="item.tcba_rec == 900">{{
                                    $t("精1")
                                }}</span>
                                <span class="hot" v-if="item.tcba_rec == 1000">{{ $t("顶1") }}</span>
                                <div class="t1 fs-18 lh-30 fw-b">{{ item.tcba_title }}</div>
                            </div>
                            <div class="df aic">
                                <span class="fs-14 c-3 f1">{{ item.time_before || item.create_time }}</span>
                                <div class="shar-box">
                                    <el-button type="text" class="li mr-16 fs-14 c-3 p-0">
                                        <span class="iconfont fs-14 icon-yanjing"></span>
                                        <span class="ml-4">{{ item.tcba_hits }}</span>
                                    </el-button>

                                    <el-button type="text" class="li mr-16 fs-14 c-3 p-0">
                                        <span class="iconfont icon-dianzan1"></span>
                                        <span class="ml-4">{{ item.tcba_likes }}</span>
                                    </el-button>
                                    <el-button type="text" class="li fs-14 c-3 p-0">
                                        <span class="iconfont icon-xiaoxi1"></span>
                                        <span class="ml-4">{{ item.reply_count }}</span>
                                    </el-button>
                                </div>
                            </div>
                        </div>

                        <div class="list p-16" v-if="curr_directory_data.tcbcd_temp_type == 20">
                            <div class="one-text mb-12 cup" @click="handleCooperateClick(item)">
                                <span class="essence" v-if="item.tcba_rec == 900">{{$t('精1')}}</span>
                                <span class="hot" v-if="item.tcba_rec == 1000">{{$t('顶1')}}</span>
                                    <!-- <img :src="getFileSrc(item.tcba_annex_arr[0].att_mime_type)" class="mr-4 w-32" alt="" /> -->
                                <img v-if="curr_directory_data.tcbcd_temp_type == 20 && item.tcba_annex_arr" :src="getDoc(item.tcba_annex_arr[0].att_title)" class="w-32 mr-4" alt="" >
                                <span class="t1 fs-18 lh-30 fw-b">{{ item.tcba_title }}</span>
                            </div>
                            <div class="">
                                <div class="df">
                                    <div class="f1">
                                        <span class="fs-14 c-3">{{ item.create_time }}</span>
                                        <span class="fs-14 c-3 ml-16" v-if="curr_directory_data.tcbcd_temp_type == 20 && item.tcba_annex_arr">
                                            {{ item.tcba_annex_arr[0].att_size }} MB
                                        </span>
                                    </div>

                                    <div class="share-box fn df aic jcfe">
                                        <template v-if="curr_directory_data.tcbcd_temp_type == 20 && item.tcba_annex_arr">
                                            <!-- 下载 -->
											<template>
											  <el-button 
											    type="text" 
											    class="li mr-16 fs-14 c-3 cup lh-19 p-0"
											    @click.stop="download(item,index)" v-throttle="1000"
											  >
											    <span class="iconfont fs-14 icon-xiazai"></span>
											    <span class="ml-4">
                                                    {{$t('下载')}}({{ item.tcba_annex_arr?.[0]?.download_times }})
											    </span>
											  </el-button>
											</template>

                                            <div class="bdsharebuttonbox shares-box share-box mr-16 c-3 lh-19">
                                                <a href="javascript:void(0)" 
                                                @mouseover="showShareMenu(item)" 
                                                @click="handleShare(item)" v-throttle="1000"
                                                    class="bds_more" :data-cmd="currentLanguage == 'cn' ? 'more' : ''">
                                                    <span class="iconfont">&#xe620;</span>
                                                    <span class="text"> {{ $t('分享') }}({{ item.tcba_share }})</span>
                                                </a>
                                                <div class="sharewx-link" style="position: absolute"
                                                    v-if="currentLanguage != 'cn'">
                                                    <div class="bdsharebuttonbox df fdc">
                                                        <a href="#" class="bds_weixin" data-cmd="weixin"
                                                            title="WeChat">WeChat</a>
                                                        <a href="#" class="bds_linkedin" data-cmd="linkedin"
                                                            title="linkedin">LinkedIn</a>
                                                    </div>
                                                </div>
                                            </div>

                                            <el-button type="text" class="li fs-14 c-3 cup lh-19 p-0">
                                                <span class="iconfont" style="color: #b7251e">&#xe616;</span>
                                                <span class="ml-4" @click.stop="soucang($event, item.tcba_id)"
                                                    style="color: #b7251e">{{ $t("收藏") }}</span>
                                            </el-button>
                                        </template>
                                        <template v-else>
                                            <!-- 下载 -->
                                            <el-button type="text" class="li mr-16 fs-14 c-3 lh-19 p-0">
                                                <span class="iconfont fs-14 icon-yanjing"></span>
                                                <span class="ml-4">{{$t('浏览')}}({{ item.tcba_hits }})</span>
                                            </el-button>

                                            <el-button type="text" class="li fs-14 c-3 lh-19 mr-16 p-0">
                                                <span class="iconfont" style="color: #b7251e">&#xe616;</span>
                                                <span class="ml-4" @click.stop="soucang($event, item.tcba_id)"
                                                    style="color: #b7251e">{{ $t("收藏") }}</span>
                                            </el-button>

                                            <el-tooltip placement="top" effect="light">
                                                <div class="hits" slot="content">
                                                    {{$t("仅华为伙伴可下载")}}
                                                </div>
                                                <div class="fs-14 c-9 lh-19" @click.stop>
                                                    <span class="iconfont">&#xe621;</span>
                                                    <span class="ml-4">{{$t('下载')}}</span>
                                                </div>
                                            </el-tooltip>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- @click="$externalto('/cooperate/info/' + item.tcba_id)" -->
                        <div class="video-list mt-18 cup" v-if="curr_directory_data.tcbcd_temp_type == 30"
                            @click="handleCooperateClick(item)">
                            <div class="poster-box">
                                <video ref="videoPlayer" @loadeddata="setCover(index)">
                                    <source :src="item.first_video_url" type="video/mp4" />
                                </video>

                                <div class="text-t1">
                                    <span class="iconfont fs-14">&#xe62d; {{ item.tcba_hits }}{{ $t('次') }}</span>
                                    <span class="iconfont fs-14 ml-12">&#xe63e; {{ item.reply_count }}</span>
                                    <el-button type="text" class="li fs-14 ml-12 p-0">
                                        <span class="iconfont" style="color: #b7251e">&#xe616;</span>
                                        <span class="ml-4" @click.stop="soucang($event, item.tcba_id)"
                                            style="color: #b7251e">{{ $t("收藏") }}</span>
                                    </el-button>
                                </div>
                            </div>

                            <div class="text-box pt-6 pl-16 pr-16 pb-16">
								<div class="t1 one-text fs-18">
									<div class="essence" v-if="item.tcba_rec == 900">{{$t('精2')}}</div>
									<div class="hot" v-if="item.tcba_rec == 1000">{{$t('顶')}}</div>
									{{ item.tcba_title }}
								</div>
                                <div class="date fs-14 c-6 mt-12">
                                    {{ item.create_time }}
                                </div>
                            </div>
                        </div>
                        
						<!-- 问答列表 -->
						<div v-if="curr_directory_data.tcbcd_temp_type == 40" 
                            @click="handleCooperateClick(item)" class="answer-list">
                            <div class="topbox">
                                <div class="topleft">
                                    <div class="t1 tow-text">
                                        {{ item.tcba_title }} 
                                    </div> 
                                    <div class="rightbtn">
                                        <el-tag size="mini" type="warning" v-if="item.tcba_is_typical == 10">
                                            {{ $t("典型疑问")}}
                                        </el-tag>
                                        <el-tag size="mini" type="success" v-if="item.tcba_is_solve == 10">
                                            {{ $t("已解决")}}
                                        </el-tag>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom">
                                <div class="titles" @click.stop="handleUserinfo(item.user_id)" v-throttle="2000">
                                    <el-avatar :size="30"
                                        :src="item.user_avatar_att_url || require('@/assets/images/avatar.png')"
                                        @error="$erroravatarHandler">
                                    </el-avatar>
                                    <p class="one-text">{{ item.user_nick_name }}</p>
                                </div>
                                <div class="dates df fww aic">
                                    <span class="mr-12">{{ item.create_time }}</span>
                                    <p><span class="iconfont">&#xe611;</span> {{ item.tcba_hits }}</p>
                                    <p><span class="iconfont">&#xe61b;</span> {{ item.tcba_likes }}</p>
                                    <p><span class="iconfont">&#xe63e;</span> {{ item.reply_count }}</p>
                                    <el-button type="text" class="li fs-14 p-0">
                                        <span class="iconfont" style="color: #b7251e">&#xe616;</span>
                                        <span class="ml-4" @click.stop="soucang($event, item.tcba_id)"
                                            style="color: #b7251e">{{ $t("收藏") }}</span>
                                    </el-button>
                                </div>
                            </div>
						</div>
                    </template>
                    <template v-if="dataList.length == 0">
                        <div class="no-data pt-86">
                            <img src="@/assets/images/empty_data.png" alt="" />
                            <p>{{ $t("暂无数据") }}</p>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <!--  -->

        <!-- 分页 -->

        <div class="pageing-box df aic jcfe mt-24" v-if="dataList.length > 0">
            <el-button type="text" class="add-btn" @click="handlePages(1)">{{
                $t("回首页")
            }}</el-button>
            <el-pagination :current-page="pagination.page" :page-size="pagination.per_page" :total="pagination.total"
                layout=" prev, pager, next,slot" @current-change="handleCurrent">
                <span class="jump-text">{{ $t("跳转") }}</span>
                <el-input-number :controls="false" v-model="jumpIndex" :min="1" :max="totalPages" @change="handleJump"
                    size="small" class="jump-ipt" style="width: 48px; margin-left: 8px" />
            </el-pagination>
            <el-button type="text" class="add-btn ml-11" @click="handlePages(totalPages)">{{ $t("去尾页") }}</el-button>
        </div>

        <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" @post-submitted="handleAvatarSubmitted" :id="id" />
    </div>
</template>

<script>
import { share } from "@api/cooperate";
import { getCollectionList, setArticleCollection } from "@api/usercenter";
import { setuserfollowAdd, userDataLv2 } from "@api/home";
import pngIcon from '@/assets/images/file/png.png';
import docIcon from '@/assets/images/file/doc.png';
import pptIcon from '@/assets/images/file/ppt.png';
import pdfIcon from '@/assets/images/file/pdf.png';
import mp4Icon from '@/assets/images/file/mp4.png';
import txtIcon from '@/assets/images/file/txt.png';
import excelIcon from '@/assets/images/file/excel.png';
import defaultIcon from '@/assets/images/file/default.png';

export default {
    data() {
        return {
            optidsName: "",
            search_key: "",
            activeName: "10",
            download_able: true,
            directory_list: [],
			publisherFollowLoading: false,
            shareItem:{},
            column: [],
            columId: 0,
            curr_column: 0,
            curr_directory: 0,
            curr_directory_data: [],
            cascaderProps: {
                value: "tcbcd_id", // 实际值字段
                label: "title", // 显示文本字段
                checkStrictly: false, // 是否可选中任意一级
                expandTrigger: "hover", // 悬浮展开
            },
            value: "",
            temp_token: "",

            options: [
                {
                    value: "zhinan",
                    label: "指南",
                    children: [
                        {
                            value: "shejiyuanze",
                            label: "设计原则",
                            children: [
                                {
                                    value: "yizhi",
                                    label: "一致",
                                },
                                {
                                    value: "fankui",
                                    label: "反馈",
                                },
                                {
                                    value: "xiaolv",
                                    label: "效率",
                                },
                                {
                                    value: "kekong",
                                    label: "可控",
                                },
                            ],
                        },
                        {
                            value: "daohang",
                            label: "导航",
                            children: [
                                {
                                    value: "cexiangdaohang",
                                    label: "侧向导航",
                                },
                                {
                                    value: "dingbudaohang",
                                    label: "顶部导航",
                                },
                            ],
                        },
                    ],
                },
            ],

            // 列表
            dataList: [],

            // 分页
            pagination: {
                total: 0,
                page: 1,
                per_page: 16,
            },
            jumpIndex: 1,
            totalPages: 1,
            shareLoading: false,
            id: 0,

            // 是否是英文版
            currentLanguage: "cn",
        };
    },
    watch: {
        optidsName(newTitle) {
            this.setSelectedValue(newTitle);
        },
    },
    mounted() {
        let Language = localStorage.getItem("currentLanguage"); //获取本地语言
        if (Language && Language != "zh") {
            this.currentLanguage = Language;
        }
        
        this.setSelectedValue(this.optidsName);

        // setTimeout(() => {
        //     window._bd_share_main.init();
        // }, 100);
    },
    created() {
        this.getCollectionList();
    },
    destroyed() {
        // window._bd_share_main.init();
    },

    methods: {
		// 根据文件类型获取图片
		getDoc(title) {
			const filePath = title;
			const fileType = filePath.split(".").pop(); // 获取扩展名

			let png = ["png", "jpg", "bmp", "tif", "gif", "pcx", "svg", "webp"];
			let doc = ["doc", "docx", "DOC", "ODCX"];
			let ppt = ["ppt", "pptx", "pps", "ppsx", "pot", "potx", "odp", "xml"];
			let pdf = [
				"pdf",
				"pdf/a",
				"pdf/x",
				"pdf/e",
				"pdf/ua",
				"pdf/1.4",
				"pdf/1.5",
				"pdf/2.0",
			];
			let mp4 = [
				"mp4",
				"mkv",
				"avi",
				"mov",
				"wmv",
				"flv",
				"webm",
				"mpeg",
				"mpg",
				"3gp",
				"mp3",
				"wav",
				"aac",
				"flac",
				"ogg",
				"wma",
				"m4a",
				"aiff",
				"opus",
			];
			let txt = [
				"txt",
				"csv",
				"log",
				"md",
				"xml",
				"json",
				"html",
				"yaml",
				"ini",
				"tex",
			];
			let excel = ["xls", "xlsx", "xlsm", "xlsb", "csv", "txt", "xml", "ods"];

			let typePath = "default";
			if (png.includes(fileType)) {
				typePath = "png";
			} else if (doc.includes(fileType)) {
				typePath = "doc";
			} else if (ppt.includes(fileType)) {
				typePath = "ppt";
			} else if (pdf.includes(fileType)) {
				typePath = "pdf";
			} else if (mp4.includes(fileType)) {
				typePath = "mp4";
			} else if (txt.includes(fileType)) {
				typePath = "txt";
			} else if (excel.includes(fileType)) {
				typePath = "excel";
			} else {
				typePath = "default";
			}

			const iconMap = {
                png: pngIcon,
                doc: docIcon,
                ppt: pptIcon,
                pdf: pdfIcon,
                mp4: mp4Icon,
                txt: txtIcon,
                excel: excelIcon,
                default: defaultIcon,
            };
            return iconMap[typePath] || defaultIcon;
		},
        getFileSrc(fileType) {
            // 将类型配置提升为常量避免重复创建（优化点）
            const TYPE_MAP = {
                png: ["png", "jpg", "bmp", "tif", "gif", "pcx", "svg", "webp"],
                doc: ["doc", "docx", "odcx"],
                ppt: ["ppt", "pptx", "pps", "ppsx", "pot", "potx", "odp", "xml"],
                pdf: [
                    "pdf",
                    "pdf/a",
                    "pdf/x",
                    "pdf/e",
                    "pdf/ua",
                    "pdf/1.4",
                    "pdf/1.5",
                    "pdf/2.0",
                ],
                media: [
                    "mp4",
                    "mkv",
                    "avi",
                    "mov",
                    "wmv",
                    "flv",
                    "webm",
                    "mpeg",
                    "mpg",
                    "3gp",
                    "mp3",
                    "wav",
                    "aac",
                    "flac",
                    "ogg",
                    "wma",
                    "m4a",
                    "aiff",
                    "opus",
                ],
                txt: ["txt", "csv", "log", "md", "json", "html", "yaml", "ini", "tex"],
                excel: ["xls", "xlsx", "xlsm", "xlsb", "csv", "ods"],
            };

            // 统一转小写处理（修复大小写敏感问题）
            const normalizedType = fileType?.toLowerCase() || "";

            // 使用 find 方法优化查找逻辑
            const typePath =
                Object.entries(TYPE_MAP).find(([_, values]) =>
                    values.includes(normalizedType)
                )?.[0] || "default";

            // 添加错误处理（修复原逻辑中最后返回 minword 的不合理情况）
            const iconName = typePath === "default" ? "default" : `${typePath}`;

            try {
                return require(`@/assets/images/${iconName}.png`);
            } catch (e) {
                console.error("图标资源加载失败:", e);
                return require("@/assets/images/default.png");
            }
        },
        handlePages(page) {
            this.pagination.page = page;
            this.handleCurrent();
        },
        handleCurrent(page) {
            this.pagination.page = page;
            this.getCollectionList();
        },
        handleJump() {
            this.pagination.page = this.jumpIndex;
            this.getCollectionList();
        },
        // download(event, params) {
        //     event.stopPropagation();
        //     console.log(this.$refs, "...");

        //     window.location.href =
        //         "/api/protal/api/post/downAnnex?content_id=" +
        //         params.tcba_id +
        //         "&att_id=" +
        //         params.tcba_annex_arr[0].att_id +
        //         "&type=40";
        // },
		download(item, index) {
			const loading = this.$loading()
			if (this.download_able) {
				this.download_able = false;
				let tcba_id = item.tcba_id;
				let file = item.tcba_annex_arr[0];
				let att_id = file.att_id;
				let num = file.download_times;
				num = num + 1;
				this.$set(this.dataList[index].tcba_annex_arr[0], 'download_times', num)
				window.location.href = "/protal/download/downAnnex?content_id=" + tcba_id + "&att_id=" + att_id + "&type=100";
				setTimeout(() => {
					this.download_able = true;
					loading.close()
				}, 2000);
			}
		},
		// 分享
		showShareMenu(item) {
			this.shareItem = item
		},
        handleShare(item) {
            this.shareLoading = true;
            let tcba_id = item.tcba_id;
            share({ tcba_id })
                .then(() => {
                    this.shareLoading = false;
                    item.tcba_share++;
                })
                .finally(() => {
                    this.shareLoading = false;
                });            

        },
        handleCooperateClick(item) {
            if (item.tcba_link_type == 20) {
				window.open('/'+this.currentLanguage + '/cooperate/info/' + item.tcba_id);
			} else if (item.tcba_link && item.tcba_link_type == 10) {
				window.open(item.tcba_link, '_blank');
			}
        },
		setCover(index) {
			const video = this.$refs.videoPlayer[index];
			video.currentTime = 2 / 24;
		},
        // 合作tab点击
        handlecp(type, curr_column, curr_directory = 0) {
            this.columId = curr_column;

            (this.activeName = type), (this.curr_column = curr_column);
            this.curr_directory = curr_directory;
            this.getCollectionList();
        },
        handleSearch() {
            this.getCollectionList();
        },
        // 获取用户信息
        getCollectionList() {
            const loading = this.$loading({
                lock: true,
                text: this.$t("拼命加载中"),
                spinner: "el-icon-loading",
                background: "rgba(255, 255, 255, 0.7)",
            });
            getCollectionList({
                type: this.activeName,
                search_key: this.search_key,
                curr_column: this.curr_column,
                curr_directory: this.curr_directory,
                page: this.pagination.page,
            }).then((res) => {
                if (res.status == 200) {
                    loading.close();
                    this.dataList = res.data.data;
                    if (this.activeName == 10) {
                        //活动
                    } else if (this.activeName == 20) {
                        //话题
                    } else if (this.activeName == 30) {
                        //讨论
                    } else if (this.activeName == 40) {
                        this.column = res.data.column;
                        this.directory_list = this.removeEmptyChildren(
                            res.data.directory_list
                        );
                        this.optidsName = res.data.directory_title;
                        this.curr_directory_data = res.data.curr_directory_data
                            ? res.data.curr_directory_data
                            : [];
                    }
                    this.temp_token = res.data.temp_token;

                    this.pagination.total = res.data.total;
                    this.pagination.per_page = res.data.per_page;

                    this.totalPages = Math.ceil(
                        this.pagination.total / this.pagination.per_page
                    );
                    if(this.activeName == 40 && this.curr_directory_data.tcbcd_temp_type==20){
                        this.$nextTick(() => {
                            this.initShare()
                        })
                    }

                }
            });
        },
        removeEmptyChildren(arr) {
            return arr.map((item) => {
                if (item.children && item.children.length === 0) {
                    delete item.children;
                }
                if (item.children && item.children.length > 0) {
                    item.children = this.removeEmptyChildren(item.children);
                }
                return item;
            });
        },
        // 根据标题设置选中的值
        setSelectedValue(title) {
            const findValue = (list, title) => {
                for (let item of list) {
                    if (item.title === title) {
                        return [item.tcbcd_id]; // 这里返回的是对应的 tcbcd_id
                    }
                    if (item.children && item.children.length > 0) {
                        const childValue = findValue(item.children, title);
                        if (childValue) {
                            return [item.tcbcd_id, ...childValue];
                        }
                    }
                }
                return null;
            };

            const selectedValue = findValue(this.directory_list, title);
            if (selectedValue) {
                this.value = selectedValue;
            }
        },
        handleClick(index) {
            this.activeName = index;
            this.pagination.page = 1;
            this.getCollectionList();
        },
        handleChange(value) {
            // console.log(value);
            this.curr_directory = value[1];
            this.getCollectionList();
        },
        async soucang(event, tcba_id) {
            // console.log(this.$refs, "...")
            // console.log(tcba_id)
            let res = await setArticleCollection({ tcba_id: tcba_id });
            if (res.status == 200) {
                this.$message.success(res.msg);
                this.getCollectionList();
            }
        },
		handleUserinfo(user_id) {
			this.id = user_id;
			this.$refs.avatarDialog.openModal();
		},
        handleaAvatar(event, item) {
            // 判断是否是实名用户
            if (
                item.ttar_type == 20 ||
                item.user_id == 0 ||
                item.user_nick_name == "" ||
                item.user_nick_name == null
            ) {
                return false;
            }
            event.stopPropagation(); // 阻止事件冒泡
            this.$refs.avatarDialog.openModal();
            this.id = item.user_id;
        },
        async handleAvatarSubmitted(id) {
            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);
            }
        },
        
		initShare() {
			setTimeout(() => {
				const setConf = (cmd, config) => {
					config.bdUrl = window.location.origin + '/'+this.currentLanguage + '/cooperate/info/' + this.shareItem.tcba_id;
					return config;
				}
				window._bd_share_config = {
					"common": {
						"bdSnsKey": {},
						"bdText": "", // 可以设置一个默认的分享文本
						"bdMini": "1",
						"bdMiniList": false,
						"bdPic": "", // 不需要分享图片
						"bdStyle": "1",
						"bdSize": "16",
						"bdUrl": "", // 初始设置的 URL
						"onBeforeClick": setConf,
					},
					"share": {},
					"image": {
						"viewList": ["tsina", "tqq", "qzone", "weixin", "sqq"],
						"viewText": "分享到：",
						"viewSize": "16"
					},
					"selectShare": {
						"bdContainerClass": null,
						"bdSelectMiniList": ["tsina", "tqq", "qzone", "weixin", "sqq"]
					}
				};
				window._bd_share_main.init();
			}, 1000);
		},
    },
};
</script>

<style lang="scss" scoped>
.tab-box {
    .cup {
        padding-bottom: 6px;
        position: relative;
    }

    .cup:hover {
        color: #b7251e;
    }

    .active {
        color: #b7251e;

        &::after {
            content: "";
            display: block;
            position: absolute;
            width: 80%;
            height: 2px;
            background: #b7251e;
            bottom: 0;
            left: 10%;
        }
    }
}

.tb-list {

    .active,
    .actives {
        color: #b7251e;
    }
}

.cooperate-listcontent {
    .list {
        border-bottom: 1px solid #e2e2e2;
        transition: border-bottom 0.36s;
        &:hover {
            border-bottom: 1px solid #b7251e;
        }
        .essence,
        .hot {
            display: inline-block;
            min-width: 18px;
            height: 18px;
            border-radius: 2px;
            font-size: 14px;
            color: #ffffff;
            line-height: 18px;
            text-align: center;
            margin-right: 4px;
            position: relative;
            padding: 0 2px;
            top: -1px;
            font-weight: normal;
        }

        .essence {
            background: rgb(215, 17, 17);
        }

        .hot {
            background: #fdb906ff;
        }
        .t1{
            transition: color 0.36s;
        }
        &:hover {
            .t1 {
                color: #b7251e !important;
            }
        }
    }

    .shar-box {
        button {
            padding: 0;
        }

        .li {
            &:hover {
                color: #b7251e !important;
            }
        }
    }

    .video-list {
        display: inline-block;
        width: calc(33.33% - 12px);
        overflow: hidden;
        margin-right: 16px;
        border-radius: 6px;
        border: 1px solid #e8e8e8;
        &:nth-child(3n) {
            margin-right: 0;
        }
        .t1{
            transition: color 0.36s;
        }
        &:hover .t1{
            color: #b7251e;
        }

        .essence,
        .hot {
            display: inline-block;
            min-width: 18px;
            height: 18px;
            border-radius: 2px;
            font-size: 14px;
            color: #ffffff;
            line-height: 18px;
            text-align: center;
            margin-right: 4px;
            position: relative;
            padding: 0 2px;
            top: -1px;
            font-weight: normal;
        }

        .essence {
            background: rgb(215, 17, 17);
        }

        .hot {
            background: #fdb906ff;
        }
        video {
            width: 100%;
            height: 100%;
            transition: transform 0.36s;
            object-fit: cover;
        }
        &:hover video{
            transform: scale(1.1);
        }

        .poster-box {
            width: 100%;
            height: 160px;
            position: relative;
            overflow: hidden;
            video{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            .text-t1 {
                position: absolute;
                width: 100%;
                height: 36px;
                background: linear-gradient(0deg, rgba(0, 0, 0, .3333333333), transparent);
                bottom: 0;
                left: 0;
                color: #fff;
                font-size: 14px;
                line-height: 36px;
                padding-left: 16px;
            }
        }
    }
    .answer-list {
        cursor: pointer;
        position: relative;
        border-bottom: 1px solid rgba(226, 226, 226, 1);
        padding: 16px;
        transition: border-color .5s ease;
        &:hover{
            border-color: #b7251e;
            .t1{
                color: #b7251e !important;
            }
        }
        .topbox{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 12px;
            position: relative;
            z-index: 2;
            .topleft{
                display: flex;
                width: calc(100% - 180px);
            }
            .t1 {
                max-width: calc(100% - 130px);
                font-size: 18px;
                line-height: 30px;
                font-weight: bold;
                color: #282828;
                transition: color .3s ease;
            }
            .rightbtn {
                flex-shrink: 0;
                padding-top: 3px;
                .el-tag {
                    margin-left: 10px;
                    border: none;
                    color: #fff;
                    &.el-tag--warning{
                        background: rgba(253, 185, 6, 1);
                    }
                    &.el-tag--success{
                        background: rgba(215, 17, 17, 1);
                    }
                }
            }

            .edit-btn {
                padding-top: 3px;
                .el-button{
                    font-size: 14px;
                }
            }
        }
        .bottom{
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .titles {
            margin-right: 20px;
            display: flex;
            align-items: center;
            p {
                max-width: 200px;
                font-size: 14px;
                color: #333;
                margin-left: 12px;
            }
        }
        .dates {
            font-size: 14px;
            color: #888888;
            p {
                margin-right: 14px;
            }
        }

    }
}

// 活动列表
.active-listcontent {
    padding-bottom: 40px;

    .list {
        width: calc(50% - 10px);
        height: 430px;
        border-radius: 6px;
        box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
        background: rgb(255, 255, 255);
        margin-top: 20px;
        overflow: hidden;
        cursor: pointer;

        &:hover {
            ::v-deep() {
                .el-image {
                    transform: scale(1.1);
                }
            }

            .list-box .title {
                color: #b7251e;
            }
        }

        .img-box {
            width: 100%;
            height: 300px;
            overflow: hidden;

            ::v-deep() {
                .image-slot {
                    height: 100%;
                }
            }

            ::v-deep .el-image {
                width: 100%;
                height: 100%;
                transition: all 1s;
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .list-box {
            padding: 16px;

            .title {
                color: rgb(25, 25, 25);
                font-size: 18px;
                font-weight: 400;
                line-height: 28px;
            }

            .desc {
                color: rgb(89, 89, 89);
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                height: 22px;
                margin-top: 8px;
            }

            .date-box {
                padding-top: 4px;

                .le {
                    color: rgb(89, 89, 89);
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 18px;

                    span {
                        font-size: 14px;
                        margin-right: 5px;
                    }
                }

                .ri {
                    ::v-deep() {
                        .el-button {
                            border: none;
                            color: #1872fd;
                            min-width: 96px;
                            height: 36px;
                            border-radius: 20px;
                            background: rgb(231, 239, 255);
                            padding: 0 16px;
                        }
                    }

                    .end {
                        color: #6d7177;
                        background: #ffffff;
                        border: 1px solid #6d7177;
                    }
                }
            }
        }

        &:nth-child(2n) {
            margin-left: 20px;
        }

        // &:nth-child(3n-1) {
        //     margin-left: 20px;
        // }
    }
}

// 话题列表
.subject-listcontent {
    margin-top: 18px;

    .list {
        padding: 16px 0px;
        border-bottom: 1px solid rgb(226, 226, 226);
        cursor: pointer;
        transition: border-bottom 0.36s;
        z-index: 10;

        &:hover {
            border-bottom: 1px solid #b7251e;

            .t1s {
                color: #b7251e;
            }
        }

        .t1s {
            color: rgb(25, 25, 25);
            font-size: 18px;
            font-weight: 400;
            line-height: 24px;
            padding: 2px 0;

            .essence,
            .hot {
                display: inline-block;
                min-width: 18px;
                height: 18px;
                border-radius: 2px;
                font-size: 14px;
                color: #ffffff;
                line-height: 18px;
                text-align: center;
                margin-right: 4px;
                position: relative;
                padding: 0 2px;
                top: -2px;
            }

            .essence {
                background: rgb(215, 17, 17);
            }

            .hot {
                background: rgb(255, 110, 0);
            }

            .show-box {
                img {
                    margin-left: 6px;
                }
            }
        }

        .desc {
            color: rgb(51, 51, 51);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            height: 44px;
            margin-top: 10px;
        }
    }

    .hot-box,
    .essence-box {
        position: relative;

        &::after {
            content: "";
            display: block;
            width: 400px;
            height: calc(100% + 1px);
            opacity: 0.6;
            position: absolute;
            right: -40px;
            top: 0;
        }
    }

    .essence-box {
        &::after {
            background: linear-gradient(-64.32deg,
                    rgba(254, 190, 8, 0.21) -2.449%,
                    rgba(196, 196, 196, 0) 96.756%);
        }
    }

    .hot-box {
        &::after {
            background: linear-gradient(-64.32deg,
                    rgba(255, 0, 0, 0.11) -2.446%,
                    rgba(196, 196, 196, 0) 96.716%);
        }
    }

    .userinfo-box {
        height: 32px;
        margin-top: 8px;

        .name {
            font-size: 14px;
            margin-left: 6px;
        }
    }

    .type {
        height: 32px;
        position: relative;
        margin-left: 18px;
        padding: 3px 18px 5px;

        &::after {
            content: "";
            display: block;
            height: 14px;
            width: 1px;
            background-color: #d8d8d8;
            position: absolute;
            top: 50%;
            margin-top: -7px;
            left: 0;
        }

        span {
            display: inline-block;
            height: 22px;
            background-color: #f0f1f1;
            border-radius: 4px;
            padding: 0 4px;
            color: #868d9f;
            line-height: 22px;
            font-size: 12px;
            margin-right: 6px;
        }
    }

    .dates {
        height: 32px;
        line-height: 32px;

        .date {
            font-size: 14px;
            color: #868d9f;
            position: relative;
            padding-left: 16px;

            &::after {
                content: "";
                display: inline-block;
                height: 12px;
                width: 1px;
                background-color: #d8d8d8;
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -6px;
            }
        }

        .comment-list {
            .li {
                color: #868d9f;
                font-size: 14px;
                margin-right: 15px;

                .iconfont {
                    margin-right: 5px;
                }

                .text {}
            }
        }
    }
}

::v-deep {
    .el-tabs__nav-wrap::after {
        width: 0;
    }
}

.search-box {
    width: 260px;


    ::v-deep() {
        .el-input__inner {
            border-radius: 20px;
        }

        .el-icon-search:before {
            color: #b7251e;
        }
    }
}

.share-box>.bdsharebuttonbox {
    &>a::after {
        width: 100%;
        height: 24px;
        content: "";
        font-family: "iconfont";
        display: inline-block;
        color: #040a16;
        font-size: 16px;
        text-align: left;
        position: absolute;
        left: 0;
        top: 0px;
    }
}

.bdsharebuttonbox {
    position: relative;
    // top: 3px;

    .bds_more {
        font-size: 14px !important;
        padding-left: 0;
        background-image: none;
        margin: 0;
        height: 21px;
        line-height: 21px;
    }

    .sharewx-link {
        width: 120px;
        background-color: #fff;
        border-radius: 6px;
        padding: 12px;
        box-shadow: 6px 10px 20px rgba(0, 0, 0, 0.2);
        left: -6px;
        top: -88px;
        opacity: 0;
        visibility: hidden;
        transition: all 0.36s;

        a {
            padding-left: 22px;
        }

        a:hover {
            color: #b7251e;
        }
    }
}

.share-box .share-box:hover {
    .sharewx-link {
        left: 0px;
        top: -88px;
        opacity: 1;
        visibility: visible;
    }
}
</style>